<quill-editor
  [class]="componentClass"
  [readOnly]="readonly || disabled"
  [modules]="defaultModules"
  [format]="'html'"
  [sanitize]="false"
  theme="snow"
  (onContentChanged)="onContentChanged($event)"
  (onEditorCreated)="onEditorCreated($event)"
  (onBlur)="onBlur()">
</quill-editor>
